import React, { useState, useRef, useEffect } from 'react';
import { Input } from './ui/input';

export function AutoSuggest({ options, value, onChange, placeholder, displayKey = 'label', valueKey = 'value', className = '', testId = '' }) {
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const selectedLabel = options.find(o => (typeof o === 'string' ? o : o[valueKey]) === value);
  const displayLabel = selectedLabel ? (typeof selectedLabel === 'string' ? selectedLabel : selectedLabel[displayKey]) : '';

  const filtered = options.filter(o => {
    const label = typeof o === 'string' ? o : o[displayKey];
    return label.toLowerCase().includes(search.toLowerCase());
  });

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div ref={ref} className={`relative ${className}`}>
      <Input
        placeholder={placeholder || 'Search...'}
        value={open ? search : displayLabel}
        onChange={(e) => { setSearch(e.target.value); if (!open) setOpen(true); }}
        onFocus={() => { setOpen(true); setSearch(''); }}
        className="h-10"
        data-testid={testId}
      />
      {open && (
        <div className="absolute z-50 mt-1 w-full max-h-48 overflow-auto bg-white border border-slate-200 rounded-lg shadow-lg">
          {filtered.length > 0 ? filtered.map((o, i) => {
            const val = typeof o === 'string' ? o : o[valueKey];
            const label = typeof o === 'string' ? o : o[displayKey];
            return (
              <button
                key={i}
                type="button"
                className={`w-full text-left px-3 py-2 text-sm hover:bg-slate-50 ${val === value ? 'bg-blue-50 text-[#005DE8] font-medium' : 'text-slate-700'}`}
                onClick={() => { onChange(val); setOpen(false); setSearch(''); }}
              >
                {label}
              </button>
            );
          }) : (
            <div className="px-3 py-2 text-sm text-slate-400">No results</div>
          )}
        </div>
      )}
    </div>
  );
}
